import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Box, Button, Container, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { axiosInstance } from 'src/network/adapter';
import { ApiEndpoints } from 'src/network/endpoints';
import { useTheme } from '@mui/material/styles';
const FrequentlyAsked = () => {
    const theme = useTheme();
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top when the component mounts
    }, []);
    const [faqdata, setFaqData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchData = () => {
        setLoading(true);
        axiosInstance
            .get(ApiEndpoints.FAQ.list)
            .then((response) => {
                setFaqData(response.data.faqs);
            })
            .catch((error) => { })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, []);
    return (
        <>
            <Box>
                <Container maxWidth='lg'
                    sx={{
                        px: { xs: 7, md: 10, lg: 5 },
                        // py: { xs: 3, sm: 3, lg: 4, xl: 10 },
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: { xs: '28px', sm: '28px', md: '38px', },
                            fontWeight: 600,
                            display: 'flex',
                            justifyContent: 'center',
                            textAlign: 'center',
                            paddingTop: { xs: '28px', md: '40px', lg: '45px', xl: '80px' },
                        }}
                    >
                        Frequently Asked Questions
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: { xs: '16px', sm: '16px', md: '20px' },
                            fontWeight: 400,
                            lineHeight: '34px',
                            display: 'flex',
                            justifyContent: 'center',
                            textAlign: 'center',
                            paddingTop: { xs: '5px', md: '10px', lg: '20px' },
                        }}
                    >
                        {/* Lorem Ipsum is simply dummy text of the printing and typesetting */}
                    </Typography>
                    {faqdata.map((panel, index) => (
                    <Box sx={{ marginTop: '30px', marginBottom: '30px' }} key={index}>
                        <Accordion sx={{ marginTop: '30px',borderBottom: `2px solid ${theme.palette.mode==='light' ? '#E5E5E5' :'#4C4C4C'}` }}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon sx={{ color: '#AAC528', fontSize: { xs: '25px', sm: '30px', md: '50px' } }} />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                                sx={{
                                    backgroundColor: theme.palette.mode === 'light' ? '#FFFFFF' : '#0F0F0F',
                                    fontSize: { xs: '16px', md: '22px' },
                                    fontWeight: 500,
                                    color: theme.palette.mode === 'light' ? '#020202':'#B4B4B4'
                                }}
                            >
                                {panel?.question}
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    // backgroundColor: '#000000',
                                    fontSize: { xs: '16px', md: '22px' },
                                    fontWeight: 400,
                                    color: theme.palette.mode === 'light' ? '#020202': '#B4B4B4',
                                    borderRadius: '8px'
                                }}
                            >
                               {panel?.answer}
                            </AccordionDetails>
                        </Accordion>
                    </Box>
                    ))}
                </Container>
            </Box>
        </>
    )
}

export default FrequentlyAsked